import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { PlaceCategory } from '@/constants/place';
import { PlaceTableColumns } from './-table/type';
export const PlaceTableFilterSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum([PlaceTableColumns.CODE, PlaceTableColumns.PLACE]).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  category: z.nativeEnum(PlaceCategory).default(PlaceCategory.ALL),
  freeText: z.string().optional(),
  businessPlaceTypeIdIn: z.array(z.string()).optional(),
  officeTypeIdIn: z.array(z.string()).optional(),
  ownershipTypeIdIn: z.array(z.string()).optional()
});